var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("MainLayout", { staticClass: "series-cards" }, [
    _c(
      "div",
      {
        staticClass: "container mw-960",
        attrs: { slot: "action-bar" },
        slot: "action-bar"
      },
      [
        _c("div", { staticClass: "row" }, [
          _c("div", { staticClass: "col-md-6 col-lg-7" }, [
            _c(
              "h5",
              {
                staticClass:
                  "action-header series-cards__header-title typography--headline typography--color-secondary pt-1 pl-10-mobile pr-10-mobile",
                attrs: {
                  title:
                    _vm.$t("publishers.sub_header.series") +
                    " > " +
                    _vm.seriesTitle
                }
              },
              [
                _vm._v(
                  "\n          " +
                    _vm._s(_vm.$t("publishers.sub_header.series")) +
                    " > " +
                    _vm._s(_vm.seriesTitle) +
                    "\n        "
                )
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "typography--body-2 typography--color-secondary" },
              [
                _c("span", { staticClass: "mr-6" }, [
                  _vm._v(
                    "\n            " +
                      _vm._s(
                        _vm.$t("series_cards.meta.series_price", {
                          price: _vm.seriesPrice
                        })
                      ) +
                      "\n          "
                  )
                ]),
                _vm._v("\n          |\n          "),
                _c("span", { staticClass: "ml-6 mr-6" }, [
                  _vm._v(
                    "\n            " +
                      _vm._s(
                        _vm.$t("series_cards.meta.card_price", {
                          price: _vm.seriesCardPrice
                        })
                      ) +
                      "\n          "
                  )
                ]),
                _vm._v("\n          |\n          "),
                _c("span", { staticClass: "ml-6" }, [
                  _vm._v(
                    "\n            " +
                      _vm._s(_vm.getShareLevelLabel(_vm.seriesShareLevel)) +
                      "\n          "
                  )
                ])
              ]
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "col-md-6 col-lg-5 hidden-sm-down" }, [
            _c("div", { staticClass: "action-btn-row" }, [
              _c(
                "button",
                {
                  staticClass: "btn btn-primary float-right ml-1 mr-1",
                  on: {
                    click: function($event) {
                      _vm.seriesEditModalIsShown = true
                    }
                  }
                },
                [
                  _vm._v(
                    "\n            " +
                      _vm._s(_vm.$t("publishers.modal.series_edit.title")) +
                      "\n          "
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "btn btn-primary float-right ml-1 mr-1",
                  on: {
                    click: function($event) {
                      _vm.coverImageEditModalIsShown = true
                    }
                  }
                },
                [
                  _vm._v(
                    "\n            " +
                      _vm._s(
                        _vm.$t("publishers.headers.actions.upload_cover_image")
                      ) +
                      "\n          "
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "btn btn-outline-primary float-right mr-1",
                  on: {
                    click: function($event) {
                      return _vm.$root.$emit(
                        "show::modal",
                        "delete-series-modal"
                      )
                    }
                  }
                },
                [
                  _vm._v(
                    "\n            " +
                      _vm._s(_vm.$t("publishers.headers.actions.remove")) +
                      "\n          "
                  )
                ]
              )
            ])
          ])
        ])
      ]
    ),
    _vm._v(" "),
    _vm.loading
      ? _c(
          "div",
          {
            staticClass: "container mw-960 mt-4 pt-1",
            attrs: { slot: "layout-body" },
            slot: "layout-body"
          },
          [
            _c("div", { staticClass: "row" }, [
              _c(
                "div",
                { staticClass: "col-12 text-center" },
                [
                  _c("LoadingBounce"),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass:
                        "typography--body-2 typography--color-disabled pb-5"
                    },
                    [
                      _vm._v(
                        "\n          " +
                          _vm._s(_vm.$t("common.loading")) +
                          "\n        "
                      )
                    ]
                  )
                ],
                1
              )
            ])
          ]
        )
      : _c(
          "div",
          {
            staticClass: "container mw-960 mt-4 pt-1",
            attrs: { slot: "layout-body" },
            slot: "layout-body"
          },
          [
            _vm._l(_vm.visibleChapters, function(chapter) {
              return _c("ChapterView", {
                key: chapter.id,
                staticClass: "row",
                attrs: { chapter: chapter, "series-item": _vm.seriesItem },
                on: {
                  "open-chapter-edit-modal": _vm.openChapterEditModal,
                  "open-remove-from-series-modal":
                    _vm.openRemoveFromSeriesModal,
                  "open-remove-card-modal": _vm.openRemoveCardModal
                }
              })
            }),
            _vm._v(" "),
            _c(
              "InfiniteLoading",
              {
                ref: "infiniteLoading",
                staticClass: "w-100",
                attrs: { "on-infinite": _vm.onInfinite }
              },
              [
                _c(
                  "div",
                  { attrs: { slot: "spinner" }, slot: "spinner" },
                  [
                    _c("LoadingBounce"),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass:
                          "typography--body-2 typography--color-disabled pb-5"
                      },
                      [
                        _vm._v(
                          "\n          " +
                            _vm._s(_vm.$t("common.loading")) +
                            "\n        "
                        )
                      ]
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c("div", {
                  staticClass: "col-12 text-center mb-5 pb-5",
                  attrs: { slot: "no-more" },
                  slot: "no-more"
                })
              ]
            )
          ],
          2
        ),
    _vm._v(" "),
    _c(
      "div",
      { attrs: { slot: "modal-area" }, slot: "modal-area" },
      [
        _vm.chapterEditModalIsShown
          ? _c("ChapterEditModal", {
              attrs: {
                chapter: _vm.chapterForEdit,
                "series-item": _vm.seriesItem
              },
              on: {
                cancel: function($event) {
                  return _vm.resetChapterForEdit()
                },
                ok: function($event) {
                  return _vm.resetChapterForEdit()
                }
              }
            })
          : _vm._e(),
        _vm._v(" "),
        _vm.seriesEditModalIsShown
          ? _c("SeriesEditModal", {
              attrs: { "series-item": _vm.seriesItem },
              on: {
                cancel: function($event) {
                  _vm.seriesEditModalIsShown = false
                },
                ok: function($event) {
                  return _vm.updateSeriesItem()
                }
              }
            })
          : _vm._e(),
        _vm._v(" "),
        _vm.coverImageEditModalIsShown
          ? _c("CoverImageEditModal", {
              attrs: { "series-item": _vm.seriesItem },
              on: {
                cancel: function($event) {
                  _vm.coverImageEditModalIsShown = false
                },
                ok: function($event) {
                  return _vm.updateSeriesItem()
                }
              }
            })
          : _vm._e(),
        _vm._v(" "),
        _c(
          "BasicModal",
          {
            attrs: {
              id: "delete-series-modal",
              title: _vm.$t("publishers.modal.remove_series.title")
            },
            on: {
              ok: function($event) {
                return _vm.remove()
              }
            }
          },
          [
            _c("div", {
              domProps: {
                innerHTML: _vm._s(
                  _vm.$t("publishers.modal.remove_series.message")
                )
              }
            })
          ]
        ),
        _vm._v(" "),
        _c(
          "BasicModal",
          {
            attrs: {
              id: "remove-from-series-modal",
              title: _vm.$t("publishers.modal.remove_from_series.title")
            },
            on: {
              ok: function($event) {
                return _vm.removeFromSeries()
              },
              cancel: function($event) {
                return _vm.resetCardIdForRemoveFromSeries()
              }
            }
          },
          [
            _c("div", {
              domProps: {
                innerHTML: _vm._s(
                  _vm.$t("publishers.modal.remove_from_series.message")
                )
              }
            })
          ]
        ),
        _vm._v(" "),
        _c(
          "BasicModal",
          {
            attrs: {
              id: "remove-card-modal",
              title: _vm.$t("publishers.modal.remove_publisher_card.title")
            },
            on: {
              ok: function($event) {
                return _vm.removeCard()
              },
              cancel: function($event) {
                return _vm.resetCardIdForRemove()
              }
            }
          },
          [
            _c("div", {
              domProps: {
                innerHTML: _vm._s(
                  _vm.$t("publishers.modal.remove_publisher_card.message")
                )
              }
            })
          ]
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-790dbd5a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-790dbd5a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/publishers/views/SeriesCards.vue
// module id = y00c
// module chunks = 1